<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="tableData"
      :columns="tableColumns"
    >
      <template v-slot:showItem="{ row }">
        <el-row :gutter="10">
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              费用项目：
              {{ row.v_expenseType }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              明细费用：
              {{ row.expenseName }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              费用金额：
              {{ row.currencyAmount }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              代用发票：
              {{ row.substituteInvoice == '0' ? '是' : '否' }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              原始费用项目：
              {{ row.v_originalExpenseType }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              费用客户：
              {{ row.custName }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              品牌：
              {{ row.brandName }}
            </span>
          </el-col>
          <!-- <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              客户订单号：
              {{ row.custOrderNo }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              外运编号：
              {{ row.customsNo }}
            </span>
          </el-col> -->
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 9 }"
          >
            <span>
              分摊部门：
              {{ row.orgDepFullName }}
            </span>
          </el-col>
        </el-row>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
  },
  data() {
    return {
      tableColumns: tableColumns(this),
    }
  },
}
</script>
